/**
 * created by tian ruo jun
 网站稿件基本信息（重要性、点击数等）
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DatePicker, Icon, Input, Select} from "antd";
const {Option} = Select;
const publishSettings = {
//栏目信息
    programaKey: 'programaFtitle',//栏目信息数据保存标题key
    programaName: '栏目',//栏目信息标题名称
//当前栏目信息
    currentColumnKey: 'currentColumnFtitle',//当前栏目信息数据保存标题key
    currentColumnName: '当前栏目',//当前栏目信息标题名称
    headlinesPlaceholder: '这是一个栏目名称',//栏目名称的提示
    currentColumnIsRequest: true,//是否必输项，
    currentColumnCheckMessage: '请选择当前栏目',
//重要性数据
    numericalKey: 'numericalFtitle',//重要性数据保存标题key
    numericalName: '重要性',//重要性信息标题名称
    numericalhint: '数值越小越重要',//重要性提示
    numericalPlaceholder: '请输入重要性',//重要性的提示
    numericalIsRequest: true,//是否必输项，
    numericalCheckMessage: '请输入重要性',
//显示位置
    locationKey: 'locationFtitle',//显示位置数据保存标题key
    locationName: '显示位置',//显示位置信息标题名称
    locationPlaceholder: '请选择显示位置',//显示位置的提示
    //点击次数
    frequencyKey: 'frequencyFtitle',//点击次数数据保存标题key
    frequencyName: '点击次数',//点击次数信息标题名称
    frequencyPlaceholder: '请输入点击次数',//点击次数的提示
    frequencyIsRequest: true,//是否必输项，
    frequencyCheckMessage: '请输入点击次数',
}
export default class OtherAttributes extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute:true,
            properties: true,
            orso: true,
            switchShow: false,
            publishInformation: {
                currentColumn: [],//当前栏目
                numerical: '',//重要性
                location: '',//显示位置
                frequency: '',//点击次数
                accretion: [],//同步数据
            }
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {publishInformation, properties} = this.state;
        return (
            <>
                <div className="otherAttributes">
                    <div className="overstriking">其他属性</div>
                    <div><Icon className="lineIcon" type={properties ? "down" : "up"}
                               onClick={this.propertiesInfor}/>
                    </div>
                </div>
                {properties ?
                    <div>
                        <div className="elseRelease">
                            <div className="unifiedStyle">发布时间</div>
                            <DatePicker showTime onChange={this.changeTime} className="elseReleaseTime"/>
                        </div>
                        <div className="tapeOut">
                            <div className="unifiedStyle">下线时间</div>
                            <DatePicker showTime onChange={this.tapeOutTime} className="elseReleaseTime"/>
                        </div>
                        <div className="elseRelease">
                            <div className="significance">
                                <div>{publishSettings.numericalName}</div>
                                <div className="importanceValue">{publishSettings.numericalhint}</div>
                            </div>
                            <Input className="elseReleaseTime" onChange={(e) => {
                                this.setData('numerical', e.target.value)
                            }} value={publishInformation.numerical}
                                   placeholder={publishSettings.numericalPlaceholder}></Input>
                        </div>
                        <div className="tapeOut">
                            <div className="unifiedStyle">{publishSettings.locationName}</div>
                            <Select className="elseReleaseTime" placeholder={publishSettings.locationPlaceholder}
                                    value={publishInformation.location ? publishInformation.location : undefined}
                                    onChange={this.selectValue}>
                                <Option value="jack">Jack</Option>
                                <Option value="lucy">Lucy</Option>
                                <Option value="Yiminghe">yiminghe</Option>
                            </Select>
                        </div>
                        <div className="tapeOut">
                            <div>{publishSettings.frequencyName}</div>
                            <Input className="elseReleaseTime" onChange={(e) => {
                                this.setData('frequency', e.target.value)
                            }} value={publishInformation.frequency}
                                   placeholder={publishSettings.frequencyPlaceholder}></Input>
                        </div>
                    </div> : ''
                }
            </>
        )
    }

    propertiesInfor = () => {
        const {properties} = this.state
        this.setState({
            properties: !properties,
        })
    }

}